/**
 * Add different action types for each action
 * To prevent overwriting states.
 * @type {string}
 */
//Shop action types
export const SEARCH_USER_API_REQUEST="USER/SEARCH_USER_API_REQUEST";
export const SEARCH_USER_API_SUCCESS="USER/SEARCH_USER_API_SUCCESS";
export const SEARCH_USER_API_FAILED="USER/SEARCH_USER_API_FAILED";